/**
 * NutriGlowUp Redesign JS
 * Clean, lightweight vanilla JS for mobile sticky CTA bar & horizontal scroll navigation.
 */
document.addEventListener('DOMContentLoaded', () => {
  initStickyCTA();
  initHorizontalScrollControls();
  initQuantityUpsellPacks();
});

/**
 * Mobile Sticky CTA Bar Observer
 */
function initStickyCTA() {
  const stickyBars = document.querySelectorAll('.product-mobile-sticky-bar, .product-sticky-bar, .sticky-atc');
  const mainAddToCart = document.querySelector('.product-form__submit, .product__atc-btn, [name="add"]');
  const footerElement = document.querySelector('footer, .footer, #footer');

  if (stickyBars.length === 0 || !mainAddToCart) return;

  let isMainBtnHidden = false;
  let isFooterVisible = false;

  function updateStickyVisibility() {
    stickyBars.forEach(bar => {
      if (isMainBtnHidden && !isFooterVisible) {
        bar.classList.add('is-visible', 'product-sticky-bar--active');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible', 'product-sticky-bar--active');
        bar.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // Observe main Add to Cart button visibility
  const mainBtnObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isMainBtnHidden = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateStickyVisibility();
      });
    },
    { threshold: 0 }
  );

  mainBtnObserver.observe(mainAddToCart);

  if (footerElement) {
    const footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isFooterVisible = entry.isIntersecting;
          updateStickyVisibility();
        });
      },
      { threshold: 0.05 }
    );

    footerObserver.observe(footerElement);
  }
}

/**
 * Horizontal Scroll Navigation Buttons (Desktop)
 */
function initHorizontalScrollControls() {
  const scrollContainers = document.querySelectorAll('.horizontal-scroll-container');

  scrollContainers.forEach((container) => {
    const parentSection = container.closest('.section, section') || container.parentElement;
    if (!parentSection) return;

    const prevBtn = parentSection.querySelector('.scroll-arrow--prev');
    const nextBtn = parentSection.querySelector('.scroll-arrow--next');

    if (!prevBtn || !nextBtn) return;

    const scrollAmount = () => container.clientWidth * 0.75;

    prevBtn.addEventListener('click', () => {
      container.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      container.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    // Update disabled state on scroll
    const checkScrollBounds = () => {
      const maxScrollLeft = container.scrollWidth - container.clientWidth - 5;
      prevBtn.disabled = container.scrollLeft <= 5;
      nextBtn.disabled = container.scrollLeft >= maxScrollLeft;
    };

    container.addEventListener('scroll', checkScrollBounds, { passive: true });
    checkScrollBounds();
  });
}

/**
 * Quantity Upsell Pack Cards Selector
 */
function initQuantityUpsellPacks() {
  const packCards = document.querySelectorAll('.upsell-pack-card');
  if (!packCards.length) return;

  packCards.forEach((card) => {
    // Card selection handler
    card.addEventListener('click', (e) => {
      // If user clicked directly on buy button, don't re-trigger card select
      if (e.target.closest('.upsell-pack-buy-btn')) return;

      // Unselect all cards
      packCards.forEach((c) => {
        c.classList.remove('is-selected');
        const radio = c.querySelector('.upsell-pack-radio');
        if (radio) radio.checked = false;
      });

      // Select clicked card
      card.classList.add('is-selected');
      const currentRadio = card.querySelector('.upsell-pack-radio');
      if (currentRadio) currentRadio.checked = true;

      // Update quantity input in product form
      const targetQuantity = card.getAttribute('data-quantity') || '1';
      const form = card.closest('form') || document.querySelector('.product-form');
      if (form) {
        const qtyInput = form.querySelector('input[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = targetQuantity;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    // Sliding Buy Button click handler inside card
    const buyBtn = card.querySelector('.upsell-pack-buy-btn');
    if (buyBtn) {
      buyBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const quantity = parseInt(buyBtn.getAttribute('data-quantity') || card.getAttribute('data-quantity') || '1', 10);
        const variantId = card.getAttribute('data-variant-id') || document.querySelector('[name="id"]')?.value;

        if (!variantId) return;

        await window.NutriCart.add({items: [{id: Number(variantId), quantity}]}, buyBtn);
      });
    }
  });
}

/**
 * Global Quick Add To Cart function & Listener for Product Cards
 */
window.quickAddToCart = async function (variantId, btnElement) {
  if (!variantId) return;
  return window.NutriCart.add({items: [{id: Number(variantId), quantity: 1}]}, btnElement);
};

// Global CustomEvent listener for cart:add
document.addEventListener('cart:add', (e) => {
  const variantId = e.detail?.id;
  if (variantId) {
    window.quickAddToCart(variantId, e.target);
  }
});

// Fail-safe global interceptor for ANY add-to-cart form submission across entire site
document.addEventListener('submit', async (e) => {
  if (e.defaultPrevented) return;
  const form = e.target.closest('form.product-form, form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
  if (!form) return;
  if (form.closest('add-to-cart-form')) return;

  e.preventDefault();
  e.stopPropagation();

  const submitBtn = form.querySelector('[type="submit"], [name="add"], .product-form__atc');
  await window.NutriCart.add(new FormData(form), submitBtn);
});

// Auto-update cart page if user is on /cart and changes quantity
document.addEventListener('change', (e) => {
  const cartPageInput = e.target.closest('.cart-page__form input[name="updates[]"]');
  if (cartPageInput) {
    const max = parseInt(cartPageInput.getAttribute('max') || '99', 10);
    if (parseInt(cartPageInput.value, 10) > max) cartPageInput.value = max;
    const form = cartPageInput.closest('form');
    if (form) {
      const updateBtn = form.querySelector('[name="update"]');
      if (updateBtn) {
        updateBtn.click();
      } else {
        form.submit();
      }
    }
  }
});
